import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface TokenMechanismMasterState {
  data: any[] | null;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allTokenMechanismMasters: any[];
}

const initialState: TokenMechanismMasterState = {
  data: null,
  currentPage: null,
  totalRecords: null,
  totalPages: null,
  allTokenMechanismMasters: [],
};

export const tokenMechanismMasterSlice = createSlice({
  name: 'tokenMechanismMaster',
  initialState,
  reducers: {
    setTokenMechanismMasters: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPage;
      state.currentPage = action.payload.data.currentPage;
    },
    setTokenMechanismMastersBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPage;
      state.currentPage = action.payload.data.currentPage;
    },
    setAllTokenMechanismMasters: (state, action) => {
      state.allTokenMechanismMasters = action.payload.data;
    },
    resetTokenMechanismMaster: (state) => {
      Object.assign(state, initialState);
    },
  },
});

export const {
  setTokenMechanismMasters,
  setTokenMechanismMastersBySearch,
  setAllTokenMechanismMasters,
  resetTokenMechanismMaster,
} = tokenMechanismMasterSlice.actions;

export const getTokenMechanismMasterData = (state: RootState) => state.tokenMechanismMaster.data;
export const getTokenMechanismMasterDataBySearch = (state: RootState) => state.tokenMechanismMaster.data;
export const getAllTokenMechanismMasterList = (state: RootState) => state.tokenMechanismMaster.allTokenMechanismMasters;
export const getTokenMechanismMasterTotalRecords = (state: RootState) => state.tokenMechanismMaster.totalRecords;

export default tokenMechanismMasterSlice.reducer;
